<template>
  <div
    class="d-md-flex justify-content-between flex-column mt-3 mb-3"
    :class="!transportItem.additionalInfoExt && !transportItem.customDescription && !transportItem.dateRangeMessages && displayDefinedElementButton ? '' : 'flex-lg-row'"
  >
    <div
      class="col-12"
      :class="hasTransportExtras ? 'col-lg-7' : ''"
    >
      <div class="mt-3">
        <div class="container-fluid w-100 text-center">
          <div
            v-if="getDescription && getDescription.length"
          >
            <p
              v-for="(paragraph, paragraphIndex) in getDescription"
              :key="`description-paragraph-${paragraphIndex}`"
              class="my-3 mx-0 p-0"
            >
              {{ paragraph }}
            </p>
          </div>
        </div>

        <div
          v-if="transportPlusMeals"
          class="d-flex flex-column flex-lg-row th-info mt-3"
        >
          <div
            class="col-12"
            :class="hasTransportExtras ? 'col-md-5' : 'col-md-3'"
          >
            <h4>Meal Inclusions</h4>
          </div>
          <div
            class="col-12"
            :class="hasTransportExtras ? 'col-md-7' : 'col-md-3'"
          >
            <p 
              v-for="(meal, mealIndex) in transportItem.transport.meals" 
              :key="`meal-${mealIndex}`"
            >
              Includes {{ meal }}
            </p> 
          </div>   
        </div>

        <div
          v-if="transportPlusMeals && serviceTravellers"
          :class="hasTransportExtras ? 'col-md-7' : 'col-md-6'"
        >
          <hr class="m-0">
        </div>
        
        <div 
          v-if="serviceTravellers" 
          class="d-flex flex-column flex-lg-row th-info"
        >
          <div
            class="col-12"
            :class="hasTransportExtras ? 'col-md-5' : 'col-md-3'"
          >
            <h4>Reservation For</h4>
          </div>
          <div
            class="col-12"
            :class="hasTransportExtras ? 'col-md-6' : 'col-md-3'"
          >
            <p>{{ serviceTravellers }}</p>  
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="hasTransportExtras"
      class="col-12"
      :class="hasTransportExtras ? 'col-lg-5' : '' "
    >
      <div
        v-if="transportItem.media && transportItem.media.images && transportItem.media.images.length"
        class="d-flex flex-row"
      >
        <div
          class="ml-lg-3 w-100 gallery-button mb-3 col mt-2"
          @click="handleOpenExperienceImageModal"
        >
          <img
            v-if="transportItem && 
              transportItem.media && 
              transportItem.media.images &&
              transportItem.media.images.length" 
            :src="transportItem.media.images.length ? addCdnImageWidth(transportItem.media.images[0], 600) : 'https://images.unsplash.com/photo-1535262412227-85541e910204?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NTV8fGJlYWNofGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60'"
            alt="transport image"
            class="th-service-image"
          >
          <button 
            class="w-100 m-0 th-button text-center rounded th-acc-btn" 
          >
            <b-icon
              class="th-button-icon-gallery"
              icon="camera"
            />
            <span class="pl-1">Gallery</span>
            <div class="th-button-placeholder" />
          </button>
        </div>
      </div>

        <div class="row d-flex flex-column align-items-center">

          <button
          v-if="transportItem.additionalInfoExt || transportItem.customDescription || (transportItem.dateRangeMessages && transportItem.dateRangeMessages.length)"
          class="col-10 ml-lg-3 mt-lg-2 p-3 th-button text-center rounded th-ess-info-btn" 
          @click="handleOpenEssInfoAccModal"
          >
          Essential Transport Information
        </button>
        <button
        v-if="displayDefinedElementButton"
        class="col-10 mt-2 ml-lg-3 mt-lg-2 p-3 th-button text-center rounded th-acc-btn" 
        @click="handleOpenDefinedInfoModal(transportItem.definedElementTypes)"
        >
        Detailed Transport Information
      </button>
      </div>
    </div>
    <!-- Transport items and experience items currently use the same image modal -->
    <ExperienceImageModal
      ref="experienceImageModal"
      :experience-item="transportItem"
    />
    <EssentialInfoAccModal
      ref="essInfoAccModal"
      :additional-information="transportItem.additionalInfoExt"
      :custom-description="transportItem.customDescription"
      :date-range-messages="transportItem.dateRangeMessages"
      title="Essential Information"
      :date="transportItem.groupdate"
    />
    <DefinedInfoModal
      ref="defined-info-modal"
    />
  </div>
</template>

<script>
import { outputTravellers, definedElementTypeCheck } from '../utils'
import ExperienceImageModal from '../modals/experience-image-modal.vue'
import EssentialInfoAccModal from '../modals/essential-info-acc-modal.vue'
import DefinedInfoModal from '../modals/defined-info-modal.vue'
import { addCdnImageWidth } from '@/lib/utilities'
export default {
components: {
  ExperienceImageModal,
  EssentialInfoAccModal,
  DefinedInfoModal
},
props: {
  transportItem: {
    type: Object
  },
  tourTravellers: {
    type: Array
  }
},
data () {
  return {
    serviceTravellers: false,
    descriptionArray: [],
    displayDefinedElementButton: false
  }
},
computed: {
  getDescription () {
    return this.descriptionArray
  },
  transportPlusMeals () {
    return this.transportItem.transport && this.transportItem.transport.meals && this.transportItem.transport.meals.length
  },
  hasTransportExtras () {
    return this.transportItem.additionalInfoExt ||
     this.transportItem.customDescription ||
     (this.transportItem.dateRangeMessages && this.transportItem.dateRangeMessages.length) ||
     (this.transportItem.media && this.transportItem.media.images && this.transportItem.media.images.length) ||
     this.displayDefinedElementButton
  }
},
mounted () {
  this.setReservationFor()
  this.buildDescriptionParagraphs(this.transportItem.description)
  this.displayDefinedElementButton = definedElementTypeCheck(this.transportItem)
},
methods: {
  addCdnImageWidth,
  setReservationFor () {
    if (this.tourTravellers.length === this.transportItem.travellers.length) {
      this.serviceTravellers = false
    } else {
      const travellers = this.transportItem.travellers
      this.serviceTravellers = outputTravellers(travellers)
    }
  },
  handleOpenExperienceImageModal () {
    this.$refs.experienceImageModal.showModal()
  },
  handleOpenEssInfoAccModal () {
      this.$refs.essInfoAccModal.showModal()
    },
    handleOpenDefinedInfoModal (definedInfoData) {
      this.$refs['defined-info-modal'].openModal(definedInfoData)
    },
    buildDescriptionParagraphs (description) {
      const paragraphArray = description.split('\n')
      this.descriptionArray = paragraphArray
    }
}
};
</script>

<style lang="scss">
@import "../../styles.scss";
.item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.item-end {
  width: 300px;
}
.toggle {
  display: flex;
  justify-content: flex-end;
}

@media only screen and (min-width: 992px) {
  .test-width {
    width: 90%;
    margin-left: 2rem;
  }
}
</style>